import classNames from 'classnames';
import styles from './DeliveryStepper.module.scss';

type Props = {
  stopsBeforeCount: number;
  eta?: string;
};

function DeliveryStepper({stopsBeforeCount, eta}: Props) {
  const totalStops = stopsBeforeCount + 1;
  const currentStopIndex = 0;

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h3 className={styles.title}>Delivery Progress</h3>
        {eta && <span className={styles.eta}>ETA: {eta}</span>}
      </div>

      <div className={styles.stepperWrapper}>
        <div className={styles.stepper}>
          {Array.from({length: totalStops}).map((_, index) => {
            const isCompleted = index < currentStopIndex;
            const isCurrent = index === stopsBeforeCount;
            const isUpcoming = index > currentStopIndex && index < stopsBeforeCount;

            return (
              <div
                key={index}
                className={classNames(styles.step, {
                  [styles.completed]: isCompleted,
                  [styles.current]: isCurrent,
                  [styles.upcoming]: isUpcoming,
                })}
              >
                <div className={styles.stepDot}>
                  {isCurrent ? (
                    <div className={styles.currentDot}>
                      <div className={styles.pulsingRing} />
                      <div className={styles.innerDot} />
                    </div>
                  ) : (
                    <span className={styles.stepNumber}>{index + 1}</span>
                  )}
                </div>
                {index < totalStops - 1 && (
                  <div
                    className={classNames(styles.connector, {
                      [styles.completedConnector]: isCompleted,
                    })}
                  />
                )}
              </div>
            );
          })}
        </div>

        <div className={styles.labels}>
          <div className={styles.labelStart}>
            {stopsBeforeCount > 0 && (
              <span className={styles.stopsLabel}>
                {stopsBeforeCount} {stopsBeforeCount === 1 ? 'stop' : 'stops'} before yours
              </span>
            )}
          </div>
          <div className={styles.labelEnd}>
            <span className={styles.yourDelivery}>Your Delivery</span>
          </div>
        </div>
      </div>

      {stopsBeforeCount === 0 && (
        <div className={styles.nextUpBadge}>
          <span className={styles.nextUpIcon}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path
                d="M12 2L4 5V11.09C4 16.14 7.41 20.85 12 22C16.59 20.85 20 16.14 20 11.09V5L12 2ZM10 17L6 13L7.41 11.59L10 14.17L16.59 7.58L18 9L10 17Z"
                fill="currentColor"
              />
            </svg>
          </span>
          <span>You're next!</span>
        </div>
      )}
    </div>
  );
}

export default DeliveryStepper;
